// A reply split into Markdown and Beads visuals. The server stamps each valid visual's fence with its turn
// (```openui turn=<id>); a fence still streaming has no closing ``` yet.
export type Segment = { kind: 'md'; text: string } | { kind: 'openui'; turn: string; src: string; done: boolean };

const OPEN = /```openui turn=(\S+)\n/g;

export function segments(text: string): Segment[] {
  const out: Segment[] = [];
  let at = 0;
  OPEN.lastIndex = 0;
  for (let m = OPEN.exec(text); m; m = OPEN.exec(text)) {
    if (m.index > at) out.push({ kind: 'md', text: text.slice(at, m.index) });
    const start = m.index + m[0].length;
    const end = text.indexOf('\n```', start);
    if (end < 0) {
      out.push({ kind: 'openui', turn: m[1] ?? '', src: text.slice(start), done: false });
      return out;
    }
    out.push({ kind: 'openui', turn: m[1] ?? '', src: text.slice(start, end), done: true });
    at = end + 4;
    OPEN.lastIndex = at;
  }
  if (at < text.length) out.push({ kind: 'md', text: text.slice(at) });
  return out;
}
